import type { MetricsDistributionResponse } from "../../../../../shared/api/types";

export interface ProgressBarData {
  label: string;
  value: number;
}

export const transformProgrammeGoals = (
  data: MetricsDistributionResponse | undefined
): ProgressBarData[] => {
  if (!data?.data?.distribution || data.data.distribution.length === 0)
    return [];

  return data.data.distribution
    .map((item) => ({
      label: (item.label || item.name || "Unknown")
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      value: item.value,
    }))
    .sort((a, b) => b.value - a.value);
};
